export const introduce = {
  text: `### 指标原理
  + 美元计价的token市值`,
  height: 1290,
};